const CONFIRMED_STATUS = 'CONFIRMED';
const CANCELED_STATUS = 'CANCELED';

/**
 * Status options a user may pick in a work order's inline status select (ZOHO-1819).
 * Confirmed is set only by invoice confirmation, so it is never offered as a manual choice;
 * a Confirmed work order can only stay Confirmed or be Canceled.
 */
export const getSelectableStatusOptions = <T extends { value: string }>(options: T[], currentStatus: string): T[] =>
  currentStatus === CONFIRMED_STATUS
    ? options.filter((o) => o.value === CONFIRMED_STATUS || o.value === CANCELED_STATUS)
    : options.filter((o) => o.value !== CONFIRMED_STATUS);
